import { useSession } from '@openx/utils/permission/useSession.ts';

export const useAccountUid = () => {
  const { session } = useSession();

  const accountUid = session?.user.account_uid;

  if (!accountUid) {
    throw new Error('Account uid not found in session');
  }

  return accountUid;
};
